














import { computed, defineComponent } from "@vue/composition-api";
import { isMobile } from "@/lib/browserUtils";
import { getDurationSymbols } from "@/lib/time";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "AudioRecordingView",
  components: { BaseIcon },
  props: {
    durationMs: { type: Number, default: 0 },
    recording: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const durationText = computed(() => {
      const durationSymbols = getDurationSymbols(props.durationMs);
      const secondsString = durationSymbols.s < 10 ? "0" + `${durationSymbols.s}` : `${durationSymbols.s}`;
      return `${durationSymbols.m}:${secondsString}`;
    });
    const onStopRecord = () => {
      emit(`stopRecord`);
    };
    const onStartRecord = (e?: TouchEvent) => {
      e?.preventDefault();
      emit("startRecord");
    };

    const onToggleRecord = () => {
      if (isMobile()) return;
      if (props.recording) {
        onStopRecord();
      } else {
        onStartRecord();
      }
    };

    return { durationText, onToggleRecord, onStartRecord, onStopRecord };
  },
});
